//import * as React from 'react';
import React, { useContext, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Divider from '@mui/material/Divider';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import { AuthContext } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';



export default function MenuAppBar({title}) {
  
  /*
  const {menuEnum, setMenuEnum} = useState({
    appItem1: "",
    appItem2: "Param",
    appItem3: "EnergieEntita"
  });
  */
 
  const { logout, role } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElApp, setAnchorElApp] = useState(null);

  const open = null;
  const navigate = useNavigate();

  const handleAppMenu = (event) => {
    setAnchorElApp(event.currentTarget);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseAppMenu = () => {
    setAnchorElApp(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    logout();
    navigate('/');
  };

  
  const renderUserMenuItems = () => {
    switch (role) {
      case 'system_admin':
        return [
            <MenuItem onClick={handleClose} key="appItem1">Můj účet</MenuItem>,
            <MenuItem component={Link} to="/Param" key="appItem2">Parametry</MenuItem>,
            <Divider key="divider1"/>,
            <MenuItem component={Link} to="/EnergieEntita" key="appItem3">Energie - entity</MenuItem>
        ];
      case 'club_admin':
        return [
            <MenuItem onClick={handleClose} key="appItem10">Profil</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem20">Můj účet</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem30">Club Dashboard</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem40">Member Management</MenuItem>,
        ];
      case 'user':
        return [
            <MenuItem onClick={handleClose} key="appItem11">Profil</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem21">Můj účet</MenuItem>
        ];
      default:
        return null;
    }
  };
  const renderAppMenuItems = () => {
    switch (role) {
      case 'system_admin':
        return [
            <MenuItem component={Link} to="/Energie" key="appItem12">Energie</MenuItem>,
            <MenuItem component={Link} to="/Zdravi" key="appItem22">Zdraví</MenuItem>,
        ];
      case 'club_admin':
        return [
            <MenuItem onClick={handleClose} key="appItem13">Kluby</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem23">Kategorie</MenuItem>
      ];
      case 'user':
        return [
            <MenuItem onClick={handleClose} key="appItem14">Kluby</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem24">Kategorie</MenuItem>,
            <MenuItem onClick={handleClose} key="appItem34">graf</MenuItem>
      ];
      default:
        return null;
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            aria-label="app menu"
            aria-controls="menu-appbar"
            aria-owns={open ? 'menu-appbar' : null}
            aria-haspopup="true"
            onClick={handleAppMenu}
            color="inherit"
            
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElApp}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElApp)}
            onClose={handleCloseAppMenu}>
            <MenuItem component={Link} to="/">Dashboard</MenuItem>
            <Divider />
            {renderAppMenuItems()}
            </Menu>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          
          {role && (
            
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-userbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
                title={role}
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-userbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {renderUserMenuItems()}
                <MenuItem onClick={handleLogout}>Odhlásit se</MenuItem>
              </Menu>
              
            </div>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
